import {Request} from 'express'
import {getRealInstallFilePath as sharedGetRealInstallFilePath} from '../../../wts-shared/utils.js'
// Type definitions
// interface UserModel {
//     isGoogleAccount(): boolean;
//     isValid(): boolean;
//     getEmail(): string;
//     email: string;
// }

// interface WTSRequest {
//     user?: UserModel;
//     WTSUserIP?: string;
//     WTSCountry?: string;
//     WTSSessionCRC?: string;
//     WTSConfirmedLegitBot?: boolean;
//     originalUrl?: string;
//     url: string;
//     session?: {
//         captcha_check_passed?: boolean;
//     };
// }

// interface WTSHeaders {
//     wtsforwardedapirequest?: string;
// }

function compareTwoStringsForSort(a: string, b: string): number {
    if (a < b)
        return -1;
    if (a > b)
        return 1;
    return 0;
}

// AA: as of 2024/06/06 local IPs are
//          ::1 - request from SSR layer 
//         *.127.0.0.1 - request via nginx
function isSSRApiCall(req: Request): boolean {
    if (req.headers && req.headers["wtsforwardedapirequest"] &&
        req.ip && req.ip.endsWith('::1')) {
            return true;
    }
    return false;
}

function isStaticPath(path: string): boolean {

    if (path.startsWith('/s/')) return true;
    return false;


    if (path.startsWith('/css/')) return true;
    else if (path.startsWith('/img/')) return true;
    else if (path.startsWith('/images/')) return true;
    else if (path.startsWith('/js/')) return true;
    else if (path.startsWith('/fonts/')) return true;
    else if (path.startsWith('/wts-images/')) return true;
    else if (path.startsWith('/ti/')) return true;
    else if (path.startsWith('/til/')) return true;
    else if (path.startsWith('/ci/')) return true;

    // those are react-generated files
    else if (path.startsWith('/bundle./')) return true; // javascript
    else if (path.startsWith('/main./')) return true; // css
    else if (path.endsWith('.ttf')) return true; // fonts

    return false;
}

function isAdminAccount(req: Request): boolean {

    if (!req || !req.user) {
        return false;
    }

    const ADMINS = [
        'artem.astrakhantsev@gmail.com',
        'dmk1492@gmail.com'
    ]

    if (req.user.isGoogleAccount()) {
        if (-1 != ADMINS.indexOf(req.user.email.toLowerCase())) {
            return true;
        }
    }

    return false;
}

function getUserInfo(req: Request): string {

    let id = req.WTSUserIP;

    if (req.user) {
        id = req.user.getEmail();
    }
    else if (req.WTSSessionCRC) { // session
        id = req.WTSSessionCRC;
    } 

    return `${id} (${req.WTSCountry})`
}

function getURLFromRequest(req: Request): string {
    if (req.originalUrl)
        return req.originalUrl;
    return req.url;
}

function getPathFromRequest(req: Request): string {
    const url = getURLFromRequest(req);
    const query = url.indexOf('?');
    if (-1 == query) return url;
    return url.substr(0, query);
}

function isForbiddenDomain(domain: string): boolean {

    var regExp1 = /^.*\.(?:gov|mil)$/g;
    var regExp2 = /^.*\.(?:gov|mil).\w\w$/g;
    var match = regExp1.exec(domain.trim());
    if (match !== null) {
        return true;
    }
    match = regExp2.exec(domain.trim());
    if (match !== null) {
        return true;
    }
    return false;
}

function isValidUserAccount(req: Request): boolean {

    if (!req || !req.user) {
        return false;
    }
 
    return req.user.isValid();
}

function isLegitBot(req: Request): boolean {
    return true == req.WTSConfirmedLegitBot;
}

function isCaptchaValidatedSession(req: Request): boolean {

    if (req && req.session && req.session.captcha_check_passed) {
        return true;
    }

    return false;
}


function getUserEmailOrNull(req: Request): string | null {

    if (req && req.user && req.user.email) {
        return req.user.email;
    }

    return null;
}

function isIPAddress(candidate: string): boolean {
    
    const PARAM_VAL_REGEX_IPADDRESS = /^([0-9])+\.([0-9])+\.([0-9])+\.([0-9])+$/;
    const PARAM_VAL_REGEX_IPV6ADDRESS = /^([0-9a-z:]+){8}$/;

    let match = PARAM_VAL_REGEX_IPADDRESS.exec(candidate);
    if (match !== null) {
        return true;
    }
    match = PARAM_VAL_REGEX_IPV6ADDRESS.exec(candidate);
    if (match !== null) {
        return true;
    }
    return false;
}

export function getErrorFromException(err: unknown) {

    if (err instanceof Error) {
        return err.stack || err.message;
    }
    else {
        return 'Unknown error'
    }
}

export function getErrorFromUnknown(err: unknown) : Error {

    if (err instanceof Error) {
        return err;
    }
    else {
        return new Error('Unknown error')
    }
}

export function getRealInstallFilePath(filePath: string) : string {
    return sharedGetRealInstallFilePath(filePath, 'wts-website');
}

export {compareTwoStringsForSort as compareTwoStringsForSort};
export {getURLFromRequest as getURLFromRequest};
export {getPathFromRequest as getPathFromRequest};
export {getUserInfo as getUserInfo};
export {getUserEmailOrNull as getUserEmailOrNull};
export {isAdminAccount as isAdminAccount};
export {isCaptchaValidatedSession as isCaptchaValidatedSession};
export {isForbiddenDomain as isForbiddenDomain};
export {isLegitBot as isLegitBot};
export {isSSRApiCall as isSSRApiCall};
export {isStaticPath as isStaticPath};
export {isValidUserAccount as isValidUserAccount};
export {isIPAddress as isIPAddress};

